import { config, dom, library } from "@fortawesome/fontawesome-svg-core";

//fas
import {
  faPhone,
  faChevronUp,
  faGlobe,
  faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";
//import { faPhone, faChevronUp,faComment,faPen,faMapMarkerAlt,faMinus,faCalendarAlt,faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

//far
//import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

//fab
import {
  faInstagram,
  faFacebook,
  faTwitter,
  faYoutube,
  faLine,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

export function fontawesome() {
  //無い場所の「豆腐□」を非表示にする
  // config.showMissingIcons = false;

  //使用するアイコンを追加
  library.add(faPhone, faChevronUp, faGlobe, faPhoneVolume);
  library.add(
    faInstagram,
    faFacebook,
    faTwitter,
    faYoutube,
    faLine,
    faXTwitter
  );

  //dom.i2svg();
  dom.watch();
}
